import { DirectoryRecord, FileRecord } from "@/shared/domain/files";

export enum FileSystemNodeType {
  File = "file",
  Directory = "directory",
}

/** Interface for a node in the file system. May be either a file or a directory. Used on the frontend to represent a node in the file system. */
export interface FileSystemNode {
  name: string;
  type: FileSystemNodeType;
}

/** Interface for a file in the file system. Used on the frontend to represent a file in the file system. */
export interface FileNode extends FileSystemNode {
  type: FileSystemNodeType.File;
  file: FileRecord;
}

/** Interface for a directory in the file system. Used on the frontend to represent a directory in the file system. */
export interface DirectoryNode extends FileSystemNode {
  type: FileSystemNodeType.Directory;
  directory: DirectoryRecord;
}

export function isDirectory(node: FileSystemNode): node is DirectoryNode {
  return node.type === FileSystemNodeType.Directory;
}

export function isFile(node: FileSystemNode): node is FileNode {
  return node.type === FileSystemNodeType.File;
}
